function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import LayerGroup from './LayerGroup';
import './LayerSwitch.css';
var mapIcon = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 6l10-4v24l-10 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 1l10 6v23l-10-5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 7l8-6v24l-8 6z"
}));

/**
 * An optional layer switcher.
 * Presents a button on the map, and the user can click it to expand a list of layers.
 * The list will be populated with all of its children (LayerGroups, DrawLayers, VectorLayers and WmsLayers) that have the name-property set.
 * There are default svg-icons in use, but they can be overridden by sending them in as props (icon)
 */
var LayerSwitch = /*#__PURE__*/function (_React$Component) {
  function LayerSwitch(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.showList = _this.showList.bind(_this);
    _this.state = {
      showList: false
    };
    return _this;
  }
  _inheritsLoose(LayerSwitch, _React$Component);
  var _proto = LayerSwitch.prototype;
  _proto.showList = function showList(e) {
    this.setState({
      showList: !this.state.showList
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      icon = _this$props.icon,
      name = _this$props.name,
      tooltip = _this$props.tooltip;
    var showList = this.state.showList;
    var mainIcon = icon || mapIcon;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "layer-switch--button-container"
    }, /*#__PURE__*/React.createElement("button", {
      className: "layer-switch--button",
      onClick: this.showList,
      title: tooltip
    }, mainIcon)), /*#__PURE__*/React.createElement("div", {
      className: 'layer-switch--container' + (!showList ? ' hidden' : '')
    }, /*#__PURE__*/React.createElement(LayerGroup, {
      name: name
    }, children)));
  };
  return LayerSwitch;
}(React.Component);
LayerSwitch.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The children of the LayerSwitch.
   */
  children: PropTypes.node,
  /**
   * Button icon, if not set will use default one
   */
  icon: PropTypes.element,
  /**
   * Name
   */
  name: PropTypes.string,
  /**
   * The tooltip to be shown on hover.
   */
  tooltip: PropTypes.string
} : {};
export default LayerSwitch;